<template>
  <v-card elevation="0" outlined class="rounded-xl">
    <v-card-title class="text-h5">
      Портфолио пользователей
    </v-card-title>
    <v-divider/>
    <v-row
      class="pa-4"
      justify="space-between"
    >
      <v-col cols="5">
        <the-lists-portfolios @open-portfolio="openPortfolio"/>
      </v-col>

      <v-divider vertical></v-divider>

      <v-col
        cols="7"
        class="d-flex text-center"
      >
        <v-scroll-y-transition mode="out-in">
          <div
              v-if="selectedId === null"
              class="text-h6 grey--text text--lighten-1 font-weight-light"
              style="align-self: center;"
          >
            Выберите пользователя
          </div>
          <achievements-table-admin v-else :achievements="portfolioAchievements" :full-name="fullName"/>
        </v-scroll-y-transition>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import AchievementsTableAdmin from "../Tables/AchievementsTableAdmin.vue";
import PrtfPortfolioApiAdminService from "../../Services/Api/Admin/PrtfPortfolioApi";
import PrtfAchievementApiAdminService from "../../Services/Api/Admin/PrtfAchievementApi";
import _ from "lodash";

const TheListsPortfolios = () => import("../Lists/TheListsPortfolios.vue")

export default {
  name: "ListPortfolios",
  components: {AchievementsTableAdmin, TheListsPortfolios},

  data: () => ({
    selectedId: null,
    fullName: "",
    search: '',
    portfolioAchievements: [],
  }),

  computed: {

  },

  watch: {
    'page': function () {
      this.scrollTop();
    },
  },

  methods: {

    openPortfolio(item) {
      this.selectedId = item.id
      this.fullName = item.full_name;
      this.fetchAchievementsPerson();
    },

    async fetchAchievementsPerson() {
      const response = await PrtfAchievementApiAdminService.index(this.selectedId);
      if (_.isNull(response)) return;

      if (!response.data.hasOwnProperty("error")) {
        this.portfolioAchievements = response.data.achievements;
      }
    },
  },

}
</script>

<style scoped>
tr.v-data-table__selected {
  background: #BDBDBD !important;
}
</style>